import { useTranslation } from "react-i18next";
import PageMeta from "../../../../shared/ui/common/PageMeta";
import { PageHeader } from "../../../../shared/ui/primitives";
import SessionAddForm from "../../../../modules/session/ui/components/AddForm/SessionAddForm";
import { useTherapist } from "../../../../context/TherapistProvider";

export default function AddSession() {
  const { t } = useTranslation();
  const { therapist } = useTherapist();

  return (
    <div className="space-y-6">
      <PageMeta />
      {/* The flow opened with a breadcrumb, so it had no first-level heading. */}
      <PageHeader title={t("session.addNewSessionPageTitle")} />
      <SessionAddForm therapistID={therapist?.id ?? ""} />
    </div>
  );
}
